//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('mieTables', {
//        templateUrl: 'views/components/views/mieTables/mieTables.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['translateService', 'modalService', 'mieTablesService', 'ttGridFactory', function (translateService, modalService, mieTablesService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                gridReady: false,
//                updating: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'mietable_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3597,
//                    parameters: {}
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.updateChanges = function () {
//                vm.model.updating = true;

//                mieTablesService.updateGrid().then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.updating = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                        vm.model.updating = false;
//                        loadGrid();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
